import React from 'react';
import { Spin, SpinProps } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

import './index.less';

const MAIN_CLASS_NAME = 'ib-spin';

type IIbSpinProps = SpinProps;

const IbSpin: React.FC<IIbSpinProps> = ({ className, ...otherProps }) => {
  const classes = [MAIN_CLASS_NAME];
  className && classes.push(className);

  return <Spin className={classes.join(' ')} indicator={<LoadingOutlined spin />} {...otherProps} />;
};

export default IbSpin;
